export { default as Img200 } from './processed/200/Happily-Never-After-2.jpg';
export { default as Img400 } from './processed/400/Happily-Never-After-2.jpg';
export { default as Imgthumb } from './processed/thumb/Happily-Never-After-2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Happily-Never-After-2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Happily-Never-After-2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      140,
      155,
      52
    ],
    "_population": 17,
    "_hsl": [
      0.19093851132686082,
      0.49758454106280187,
      0.40588235294117647
    ]
  },
  "LightVibrant": {
    "_rgb": [
      234,
      210,
      193
    ],
    "_population": 80,
    "_hsl": [
      0.06910569105691056,
      0.49397590361445753,
      0.8372549019607842
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      100,
      113,
      36
    ],
    "_population": 25,
    "_hsl": [
      0.1948051948051948,
      0.5167785234899329,
      0.292156862745098
    ]
  },
  "Muted": {
    "_rgb": [
      151,
      151,
      97
    ],
    "_population": 603,
    "_hsl": [
      0.16666666666666666,
      0.217741935483871,
      0.48627450980392156
    ]
  },
  "LightMuted": {
    "_rgb": [
      199,
      181,
      158
    ],
    "_population": 935,
    "_hsl": [
      0.09349593495934962,
      0.26797385620915026,
      0.7
    ]
  },
  "DarkMuted": {
    "_rgb": [
      75,
      71,
      54
    ],
    "_population": 1981,
    "_hsl": [
      0.1349206349206349,
      0.16279069767441864,
      0.2529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Happily-Never-After-2.js